export const getSkillGroupId = (skillGroup) => skillGroup?.skillGroupId;

export const getSkillGroupDefaultLabel = (skillGroup) => skillGroup?.name || translate('[No name]');

export const isSkill = (skill) => !!skill?.skillId;

export const isSkillGroupExpanded = (group) => !!group?.expanded;

export const getSkillId = (skill) => skill?.skillId;

export const getSkillDefaultLabel = (skill) => skill?.name || translate('[No name]');

export const getSkillDefaultDescription = (skill, { disabled }) => (disabled ? '' : skill?.description || '');

export const getSkillProficiency = (skill) => skill?.skillProficiencyValue;

export const setSkillProficiency = (item, skillProficiencyValue) => ({
  ...item,
  skillProficiencyValue,
});

export const isSelectedSkillsExceeded = (skillsData: any[], maxNumberOfSelectedSkills: number) =>
  maxNumberOfSelectedSkills !== null && skillsData.length > maxNumberOfSelectedSkills;
